import { useEffect } from 'react';

const useAdSense = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = process.env.REACT_APP_ADSENSE_URL!;
     script.async = true;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);
};

export default useAdSense;